import { Box, Grid, Link, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { PageTitle } from "@sagecentral/core-ui";
import { useState } from "react";
import WorkItemDraftsDrawer from "../drafts/drawer/WorkItemDraftsDrawer";
import { set } from "lodash";

const FontStyleDef = {
    fontSize: '16px',
    lineHeight: '24px',
    color: 'black',
    marginBottom: '40px',
    marginLeft: '20px'
};

const LinkStyle = styled(Link)({
    ...FontStyleDef,
    color: '#0066CC'
});

const ParentFontStyleDef = {
    ...FontStyleDef,
    display: "block",
    width: '90%'
};

const DraftWorkitemName = {
    ...FontStyleDef,
    fontWeight: 'bold'
}

type WorkItemCreateHeaderProps = {
    draftName: string | undefined
};

const WorkItemCreateHeader = (props: WorkItemCreateHeaderProps) => {
    const [openDrafts, setOpenDrafts] = useState(false);
    const onHandleViewDrafts = () => setOpenDrafts(!openDrafts);

    return (
        <Box>
            <Grid sx={{alignItems: 'center'}} container xs={12}>
                <Grid 
                    sx={{
                        display: "flex",
                        alignItems: "end",
                        minWidth: '350px'
                    }}>
                    <PageTitle sx={{ color: '#001A69' }}>
                        Create New Work Item
                    </PageTitle>
                </Grid>
                {props.draftName &&
                    <Grid xs sx={{display: 'flex', justifyContent: 'flex-start'}}>
                        <Typography sx={DraftWorkitemName}>
                            Draft Work Item Name:
                        </Typography>
                        <Typography sx={FontStyleDef}>{props.draftName}</Typography>
                    </Grid>
                }
            </Grid>
            <WorkItemDraftsDrawer opener={openDrafts} onClose={() => setOpenDrafts(false)} />
        </Box>
    );
};

export default WorkItemCreateHeader;